import Header from "./header";
import Main from "./main/main";
import Footer from "./footer";

const Layout = () => (
  <>
    <Header />
    <Main />
    <Footer />
  </>
);

export default Layout;
